/**
 * Product Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines product-related routes.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS, USER_ROLES } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

// Products feature pages
const ProductsPage = lazy(() => import('@/features/products/ui/pages/products-page'));
const ProductDetailPage = lazy(() => import('@/features/products/ui/pages/product-detail-page'));
const AddProductPage = lazy(() => import('@/features/products/ui/pages/add-product-page'));
const TiraCatalogPage = lazy(() => import('@/features/products/ui/pages/tira-catalog-page'));
const ProductLearnMorePage = lazy(() => import('@/features/products/ui/pages/product-learn-more-page'));

export const productRoutes: RouteGroup = {
  name: 'products',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.PRODUCTS,
      component: ProductsPage,
      meta: {
        title: 'products:title',
        icon: 'SquaresPlusIcon',
        showInNav: true,
        navOrder: 6,
      },
    },
    {
      path: ROUTE_PATHS.TIRA_CATALOG,
      component: TiraCatalogPage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
      },
      meta: {
        title: 'products:catalog.title',
        parent: ROUTE_PATHS.PRODUCTS,
      },
    },
    {
      path: ROUTE_PATHS.PRODUCT_CREATE,
      component: AddProductPage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
      },
      meta: {
        title: 'products:create.title',
        parent: ROUTE_PATHS.PRODUCTS,
      },
    },
    {
      path: ROUTE_PATHS.PRODUCT_LEARN_MORE,
      component: ProductLearnMorePage,
      meta: {
        title: 'products:learnMore.title',
        parent: ROUTE_PATHS.PRODUCT_CREATE,
      },
    },
    {
      path: ROUTE_PATHS.PRODUCT_DETAIL,
      component: ProductDetailPage,
      meta: {
        title: 'products:detail.title',
        parent: ROUTE_PATHS.PRODUCTS,
      },
    },
    {
      path: ROUTE_PATHS.PRODUCT_EDIT,
      component: ProductDetailPage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
      },
      meta: {
        title: 'products:edit.title',
        parent: ROUTE_PATHS.PRODUCT_DETAIL,
      },
    },
  ],
};
